import { render, staticRenderFns } from "./RentalDevicesCatalog.vue?vue&type=template&id=08dafb3a&scoped=true&"
import script from "./RentalDevicesCatalog.vue?vue&type=script&lang=ts&"
export * from "./RentalDevicesCatalog.vue?vue&type=script&lang=ts&"
import style0 from "./RentalDevicesCatalog.vue?vue&type=style&index=0&id=08dafb3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dafb3a",
  null
  
)

export default component.exports